import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { Layout } from './pages/Layout/Layout';
import { SiteLoading } from './pages/Layout/Login/SiteLoading';

import { GlobalNotification } from '@components/Notification/GlobalNotification';
import GlobalProcessing from '@components/Notification/GlobalProcessing';
import { useAppDispatch } from '@store/hooks';
import { useAuthSession } from 'src/auth/hooks/useAuthSession';
import { setUser } from 'src/store/slices/userSlice';

const App = () => {
  const dispatch = useAppDispatch();
  const { status, user } = useAuthSession();

  useEffect(() => {
    if (status === 'authenticated' && user) {
      dispatch(
        setUser({
          username: user.displayName ?? '',
          family_name: '',
          given_name: '',
          email: '',
          currentCompany: {
            name:
              user.workspaceContext?.companyName ??
              user.workspaceContext?.tenantName ??
              '',
            id: user.workspaceContext?.companyId ?? '',
            tenantId: user.workspaceContext?.tenantId ?? '',
            tenantName: user.workspaceContext?.tenantName ?? '',
          },
        })
      );
    }
  }, [status, user, dispatch]);

  if (
    status === 'restoring' ||
    status === 'authenticating' ||
    status === 'refreshing'
  ) {
    return <SiteLoading />;
  }

  if (status === 'authenticated') {
    return (
      <Layout>
        <Outlet />
        <GlobalNotification />
        <GlobalProcessing />
      </Layout>
    );
  }

  return <div>Redirecting...</div>;
};

export default App;
